import { useState, useEffect } from 'react';
import { ComponentRead } from '../apiTypes';
import { listComponents } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export function useComponents(reportId?: string) {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [components, setComponents] = useState<ComponentRead[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId) return;

    const loadComponents = async () => {
      setLoading(true);
      try {
        const data = await listComponents(reportId);
        setComponents(data);
        setError(null);
      } catch (err) {
        setError('Errore nel caricamento dei componenti');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadComponents();
  }, [reportId]);

  return { components, loading, error };
}
